<template>
  <with-title :title="$t('combined_products_tab_title')">
    <Catalog
      class="product-combined-products__catalog"
      endpoint="/shop/catalog/get-combined-products/"
      :product-uid="productUid"
      product-page
    />
  </with-title>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import Catalog from '../../Catalog'
import WithTitle from '../layouts/WithTitle'

export default {
  name: 'ProductCombinedProducts',
  components: { WithTitle, Catalog },
  computed: {
    ...mapState({
      productUid: state => state.productInfo.productInfo.uid,
      combinedProducts: state => state.productInfo.productInfo.combinedProducts
    })
  },
  methods: {
    ...mapMutations(['SET_PRODUCTS_INFO'])
  },
  mounted () {
    this.SET_PRODUCTS_INFO(this.combinedProducts)
  }
}
</script>

<style scoped>

</style>
